import React from 'react';
import Logo from './fullLogo.svg?react';
import { useResolveMantineColor } from 'src/UI/theme/theme';

type Props = {
  height?: string | number | undefined;
  width?: string | number | undefined;
  color?: string;
};

export default function FullLogoIcon({ height, width, color = 'white' }: Props) {
  const resolvedColour = useResolveMantineColor(color);

  let calcWidth = width;
  if (!calcWidth && height && typeof height === 'number') {
    calcWidth = height * (100 / 32);
  } else if (!calcWidth && !height) {
    calcWidth = 100;
  }
  let calcHeight = height;
  if (!calcHeight && !height) {
    calcHeight = 32;
  }

  return <Logo fill={resolvedColour} height={calcHeight} width={calcWidth} />;
}
